/****************************/
/* form                     */
/****************************/

export default function Form(){

    /****************************/
    /* Checkbox - focus         */
    /****************************/
    const checkwrap = document.querySelectorAll('.checkwrap');

    Array.prototype.forEach.call(checkwrap, (el, i) => {
        const checkBox = el.querySelector('input[type=checkbox');
        checkBox.addEventListener('focus', (e) => {
        e.target.parentNode.classList.add('focus');
        });

        checkBox.addEventListener('blur', (e) => {
            e.target.parentNode.classList.remove('focus');
        });
    });


}